export const PasswordRequirements = {
  expression: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&.]).{10,150}$/,
  label:
    "Het wachtwoord moet ten minste 10 karakters bevatten, 1 hoofdletter en 1 kleine letter, 1 getal en 1 speciaal teken",
};
